"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const StatusBarConstants_1 = require("./StatusBarConstants");
const StatusBarIcon = (props) => {
    var _a;
    const { icon, size } = props;
    if (!icon.name) {
        return null;
    }
    const wrapperClasses = icon.alignment === StatusBarConstants_1.LEFT ? 'flex-order-1 margin-right-5' : 'flex-order-2 margin-left-5';
    const iconClasses = (0, classnames_1.default)('rioglyph', icon.name, (_a = icon.color) !== null && _a !== void 0 ? _a : 'text-color-gray', size === StatusBarConstants_1.SMALL && 'text-size-h3', size === StatusBarConstants_1.LARGE && 'text-size-h2', icon.className);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: wrapperClasses }, { children: (0, jsx_runtime_1.jsx)("span", { className: iconClasses }) })));
};
exports.default = StatusBarIcon;
